import { useState, useEffect } from 'react'

export function useCountdown() {
  // Start at 23:58:54 -> 23 * 3600 + 58 * 60 + 54 = 82800 + 3480 + 54 = 86334
  const [secondsLeft, setSecondsLeft] = useState(86334)

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 0) return 86399 // Reset to 23:59:59
        return prev - 1
      })
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const hours = Math.floor(secondsLeft / 3600)
  const minutes = Math.floor((secondsLeft % 3600) / 60)
  const seconds = secondsLeft % 60

  const format = (num: number) => num.toString().padStart(2, '0')

  return {
    hours: format(hours),
    minutes: format(minutes),
    seconds: format(seconds),
  }
}
